import type * as Types from '@shared/types/graphqlGenerated';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type PublicJourneyPackageUnauthenticatedSignUpSignInQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type PublicJourneyPackageUnauthenticatedSignUpSignInQuery = { viewer: { __typename: 'Viewer', journeyPackage: { __typename: 'LabsJourneyPackage', id: string, name: string, practitionerName: string | null, biomarkerCount: number, description: string, discount: number, totalPrice: number } | null | { __typename: string }; } | null; };


export const PublicJourneyPackageUnauthenticatedSignUpSignInQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicJourneyPackage_UnauthenticatedSignUpSignIn_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"journeyPackage"},"name":{"kind":"Name","value":"node"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LabsJourneyPackage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"practitionerName"}},{"kind":"Field","name":{"kind":"Name","value":"biomarkerCount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export type PublicJourneyPackageUnauthenticatedSignUpSignInQueryQueryResult = Apollo.QueryResult<PublicJourneyPackageUnauthenticatedSignUpSignInQuery, PublicJourneyPackageUnauthenticatedSignUpSignInQueryVariables>;

export function usePublicJourneyPackageUnauthenticatedSignUpSignInQuery(baseOptions: Apollo.QueryHookOptions<PublicJourneyPackageUnauthenticatedSignUpSignInQuery, PublicJourneyPackageUnauthenticatedSignUpSignInQueryVariables> & ({ variables: PublicJourneyPackageUnauthenticatedSignUpSignInQueryVariables; skip?: boolean; } | { skip: boolean; })) {
  const result = Apollo.useQuery<PublicJourneyPackageUnauthenticatedSignUpSignInQuery, PublicJourneyPackageUnauthenticatedSignUpSignInQueryVariables>(
    PublicJourneyPackageUnauthenticatedSignUpSignInQueryDocument,
    baseOptions
  );
  const viewer_journeyPackage = result.data?.viewer?.journeyPackage && result.data?.viewer?.journeyPackage.__typename && ['LabsJourneyPackage'].includes(result.data?.viewer?.journeyPackage.__typename)
  ? result.data?.viewer?.journeyPackage as Extract<NonNullable<NonNullable<PublicJourneyPackageUnauthenticatedSignUpSignInQuery>['viewer']>['journeyPackage'], { __typename: 'LabsJourneyPackage' }>
  : null;

  const narrowed = result.data ? {
    ...result.data,
    viewer: {
      ...result.data?.viewer,
      journeyPackage: viewer_journeyPackage,
    },
  } : null;

  return { ...result, data: narrowed };
}

export function usePublicJourneyPackageUnauthenticatedSignUpSignInLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicJourneyPackageUnauthenticatedSignUpSignInQuery, PublicJourneyPackageUnauthenticatedSignUpSignInQueryVariables>) {
  const [originalQuery, queryInfo] = Apollo.useLazyQuery<PublicJourneyPackageUnauthenticatedSignUpSignInQuery, PublicJourneyPackageUnauthenticatedSignUpSignInQueryVariables>(
    PublicJourneyPackageUnauthenticatedSignUpSignInQueryDocument,
    baseOptions
  );

  const narrowedQuery = (options?: Apollo.QueryOptions<PublicJourneyPackageUnauthenticatedSignUpSignInQueryVariables>) => {
    return originalQuery(options).then(result => {
  const viewer_journeyPackage = result.data?.viewer?.journeyPackage && result.data?.viewer?.journeyPackage.__typename && ['LabsJourneyPackage'].includes(result.data?.viewer?.journeyPackage.__typename)
  ? result.data?.viewer?.journeyPackage as Extract<NonNullable<NonNullable<PublicJourneyPackageUnauthenticatedSignUpSignInQuery>['viewer']>['journeyPackage'], { __typename: 'LabsJourneyPackage' }>
  : null;

  const narrowed = result.data ? {
    ...result.data,
    viewer: {
      ...result.data?.viewer,
      journeyPackage: viewer_journeyPackage,
    },
  } : null;

  return { ...result, data: narrowed };
    });
  };

  return [narrowedQuery, queryInfo] as const;
}

export function usePublicJourneyPackageUnauthenticatedSignUpSignInSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublicJourneyPackageUnauthenticatedSignUpSignInQuery, PublicJourneyPackageUnauthenticatedSignUpSignInQueryVariables>) {
  const result = Apollo.useSuspenseQuery<PublicJourneyPackageUnauthenticatedSignUpSignInQuery, PublicJourneyPackageUnauthenticatedSignUpSignInQueryVariables>(
    PublicJourneyPackageUnauthenticatedSignUpSignInQueryDocument,
    baseOptions
  );
  const viewer_journeyPackage = result.data?.viewer?.journeyPackage && result.data?.viewer?.journeyPackage.__typename && ['LabsJourneyPackage'].includes(result.data?.viewer?.journeyPackage.__typename)
  ? result.data?.viewer?.journeyPackage as Extract<NonNullable<NonNullable<PublicJourneyPackageUnauthenticatedSignUpSignInQuery>['viewer']>['journeyPackage'], { __typename: 'LabsJourneyPackage' }>
  : null;

  const narrowed = result.data ? {
    ...result.data,
    viewer: {
      ...result.data?.viewer,
      journeyPackage: viewer_journeyPackage,
    },
  } : null;

  return { ...result, data: narrowed };
}
